import { IOrderFlexibleColumns } from '../../../../components/reusable/Table/types';
import { TFunction } from 'i18next';

export enum TABLE_COLUMNS_IDS {
  ROLE = 'role.name',
  USER = 'user.name',
  EMAIL = 'user.email',
  PERMISSION = 'permission',
  ACCESS = 'access',
  ACTIONS = 'ACTIONS',
}

const defaultOrderBy = TABLE_COLUMNS_IDS.ROLE;

function _getTableColumns(t: TFunction): IOrderFlexibleColumns[] {
  return [
    {
      id: TABLE_COLUMNS_IDS.ROLE,
      label: t('common.role'),
      key: TABLE_COLUMNS_IDS.ROLE,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.ROLE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.USER,
      label: t('common.user'),
      key: TABLE_COLUMNS_IDS.USER,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.USER,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.EMAIL,
      label: t('common.email'),
      key: TABLE_COLUMNS_IDS.EMAIL,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.EMAIL,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.PERMISSION,
      label: t('common.permission'),
      key: TABLE_COLUMNS_IDS.PERMISSION,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.PERMISSION,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ACCESS,
      label: t('superAdminDashboard.access'),
      key: TABLE_COLUMNS_IDS.ACCESS,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: TABLE_COLUMNS_IDS.ACCESS,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIONS,
      key: TABLE_COLUMNS_IDS.ACTIONS,
      type: 'string',
      sortable: false,
      sortingKey: TABLE_COLUMNS_IDS.ACTIONS,
      align: 'left',
      hided: false,
      isFixed: true,
      canHide: false,
    },
  ];
}

const getTableColumns = (t: TFunction) => _getTableColumns(t);

const hidedColumns: string[] = [];

export const getDefaultSettings = (t: TFunction) => ({
  columnsOrderIds: Object.keys(_getTableColumns(t)).filter(
    (columnId) => !hidedColumns.includes(columnId),
  ),
  orderBy: defaultOrderBy,
  order: 'asc',
  hidedColumns,
});

export default getTableColumns;
